<template>
  <v-menu :value="showMenu" :position-x="x" :position-y="y" absolute offset-y>
    <v-list dense>
      <v-list-item @click="activateAction('edit', 'ductEntryForm')">
        <v-list-item-title>{{ $t("Edit") }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="activateAction('resize', 'ductEntryTypeSelector')">
        <v-list-item-title>{{ $t("ChangeType") }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="activateAction('move', 'ductEntryAction')">
        <v-list-item-title>{{ $t("Move") }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="activateAction('clone', 'ductEntryAction')">
        <v-list-item-title>{{ $t("Clone") }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="remove">
        <v-list-item-title>{{ $t("Delete") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DuctEntryMenu",

  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    x: {
      required: true
    },

    y: {
      required: true
    },
    ductEntryIndex: {
      type: Number | undefined
    }
  },

  methods: {
    ...mapActions([
      "setSelectedDuctEntryIndex",
      "setMasksTabSideSection",
      "setDuctEntryMode"
    ]),

    activateAction(ductEntryMode, tabSideSection) {
      this.setSelectedDuctEntryIndex(this.ductEntryIndex);
      this.setDuctEntryMode(ductEntryMode);
      this.setMasksTabSideSection(tabSideSection);
    },

    remove() {
      this.$emit("delete", this.ductEntryIndex);
      this.setMasksTabSideSection("toolbar");
      this.setSelectedDuctEntryIndex(undefined);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryMenu.vue